import React from 'react';
import { DailyDecisionDashboard } from '../components/dashboard/DailyDecisionDashboard';

export const Dashboard: React.FC = () => {
  // Get user ID from context/auth if available
  // const { user } = useAuth(); // Uncomment when auth is implemented
  
  return (
    <DailyDecisionDashboard 
      // userId={user?.id} // Pass user ID when available
      autoRefresh={true}
      refreshInterval={60000} // Refresh every minute
    />
  );
};
